import React from 'react';

const FieldDetail = ({
  title,
  children,
  className,
}: {
  title: String;
  children: React.ReactNode;
  className?: any;
}) => {
  return (
    <>
      <div
        className={`w-full flex  px-3 justify-between   py-4 border-b last:border-none  last:pb-0   border-light-grey ${className}`}
      >
        <p>{title}</p>
        {/* <p>  {formatMoney(items?.value, 'Rs')}</p> */}
        <p className="text-[black] font-normal">{children}</p>
      </div>
    </>
  );
};

export default FieldDetail;
